import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/DecimalField/text";

export class DecimalFieldtext extends BaseFormItem {

    constructor(props) {
        super(props);
        this.__enablePureOverValueAndEnabledHandling();
    }

    render() {
        const { value, enabled } = this.state;
        return <Control
            {...this.getPlumbingProps()}
            value={value}
            enabled={enabled}
        />;
    }
}

export default DecimalFieldtext;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/DecimalField/text.js